import styled from "styled-components";

export const ReservationWrapper = styled.div<{ inset: number | null }>`
  margin-top: ${(p) => (p.inset ? `${p.inset}px` : "0px")};
  padding-bottom: ${(p) => (p.inset ? `${p.inset}px` : "0px")};
  padding-top: 48px;
  overflow: auto;
  height: 100vh;

  > img {
    position: relative;
    top: 0px;
    width: 100%;
  }
`;

export const ReservationInfoWrapper = styled.div`
  padding: 20px 16px 125px;

  > .title {
    font-weight: 700;
    font-size: 20px;
    line-height: 100%;
  }

  > .warning {
    margin-top: 5px;
    font-size: 11px;
    font-weight: 600;
    text-align: left;
    color: #8c8a8a;
  }
`;

export const ReservationInfo = styled.div`
  margin-top: 12px;
  padding: 20px 16px;
  width: 100%;
  height: 103px;
  border-radius: 8px;
  background: var(--Black-100, #f0f0f0);
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  > .row {
    display: flex;
    align-items: center;
    color: var(--Black-500, #202020);
    gap: 18px;
    font-size: 13px;
    line-height: 160%;

    > .name {
      width: 48px;
      font-weight: 600;
    }

    > .value {
      font-weight: 400;
    }
  }
`;

export const ReservationButtonWrapper = styled.div`
  position: fixed;
  bottom: 0;
  box-shadow: 0px 0px 12px 0px #00000040;
  width: 100%;
  height: 98px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 15px 16px 35px;
  gap: 10px;

  > .button {
    flex: 1;
    height: 48px;
    border-radius: 8px;
    gap: 8px;
    background: var(--Purple-300, #6436e7);
    font-weight: 600;
    font-size: 15px;
    line-height: 48px;
    text-align: center;
    color: #fff;

    &.cancel {
      background: #ff0004;
    }
  }
`;

export const ReservationStateButton = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 600;
  font-size: 10px;
  text-align: center;
  color: #121212;
  align-items: center;
  justify-content: center;

  > img {
    width: 36px;
  }
`;
